const META = {
  PIXEL_ID:     "709535078796092",
  EVENTS_URL:  "https://connect.facebook.net/en_US/fbevents.js",
  SESSION_KEY: "meta-insight-sent",
};

export default META;

